const common = require("lib/labels/_common");

module.exports = {
  list:{
    information: {
      en: "Information",
      fr: "Informations"
    }
  },
  projectList: {
    title: {
      en: "Projects",
      fr: "Projets"
    },
    edit: common.edit,
    remove: common.remove,
    detailed: {
      name: common.name,
      description: common.description,
      users: common.users,
      app: {
        en: "Apps",
        fr: "Apps"
      },
      services: {
        en: "Services",
        fr: "Services"
      },
      files: {
        en: "Files",
        fr: "Fichiers"
      },
      licences: {
        en: "Licences",
        fr: "Licences"
      }
    },
    members: {
      en: "Members",
      fr: "Membres"
    },
    licencesAndRoles: {
      en: "Licences and roles",
      fr: "Licences et rôles"
    },
    noUsers: {
      en: "No members",
      fr: "Aucun membre"
    },
    noRoles: {
      en: "No roles",
      fr: "Aucun rôle"
    }
  },
  projectForm: {
    stepTitle: {
      en: "General",
      fr: "Général"
    },
    title: {
      creation: {
        en: "New Project",
        fr: "Nouveau Project"
      },
      edition: {
        en: "Edit Project",
        fr: "Edition de projet"
      }
    },
    licences: {
      en: "Licences",
      fr: "Licences"
    },
    name: common.name,
    description: common.description
  },
  roleForm: {
    title: {
      en: "Roles",
      fr: "Rôles"
    },
    name: common.name,
    rights: {
      en: "Rights",
      fr: "Droits"
    },
    role: {
      en: "Role",
      fr: "Rôle"
    },
    back: {
      en: "Back",
      fr: "Retour"
    },
    valid: {
      en: "Validate",
      fr: "Valider"
    },
    searchByName: {
      en: "Research by name",
      fr: "Recherche par nom"
    },
    searchLic: {
      en: "Search a licence (filter)",
      fr: "Rechercher une licence (filtre)"
    },
    rolesAndLicences: {
      en: "Roles  \\  Licences",
      fr: "Roles  \\  Licences"
    },
    limitMaxProject:{
      en: "limit on the number of project using this licence reached",
      fr: "La licence a atteint son nombre maximum d'utilisation dans les projets"
    },
    msgIndicator:{
      en:"Click logos to add licences",
      fr:"Ajoutes une licence en cliquant sur un logo"
    }
  },
  userForm: {
    title: {
      en: "Project members",
      fr: "Membres du projet"
    },
    user: {
      en: "User",
      fr: "Utilisateur"
    },
    role: {
      en: "Role",
      fr: "Rôle"
    },
    searchUser: {
      en: "Search user",
      fr: "Recherche utilisateur"
    },
    back: {
      en: "Back",
      fr: "Retour"
    },
    valid: {
      en: "Validate",
      fr: "Valider"
    }
  }
};
